import React from 'react'
import axios from 'axios'

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || ''

class LoginForm extends React.Component {
  btnRef = React.createRef()
  isLoggingIn = false
  state = {
    error: '',
  }

  componentDidMount() {
    if (!GOOGLE_CLIENT_ID) {
      this.setState({
        error: '未配置 Google 登录 Client ID',
      })
      return
    }

    const initGoogle = (retryCount = 0) => {
      if (!window.google || !window.google.accounts) {
        if (retryCount >= 50) {
          this.setState({
            error: 'Google 登录组件加载失败，请检查网络或稍后重试',
          })
          return
        }
        this.googleInitTimer = setTimeout(() => initGoogle(retryCount + 1), 200)
        return
      }
      window.google.accounts.id.initialize({
        client_id: GOOGLE_CLIENT_ID,
        callback: this.handleGoogleSuccess,
      })
      if (this.btnRef.current) {
        window.google.accounts.id.renderButton(this.btnRef.current, {
          theme: 'outline',
          size: 'large',
          shape: 'pill',
          text: 'signin_with',
          locale: 'zh-CN',
        })
      }
    }
    initGoogle()
  }

  componentWillUnmount() {
    if (this.googleInitTimer) {
      clearTimeout(this.googleInitTimer)
    }
  }

  handleGoogleSuccess = (response) => {
    if (this.isLoggingIn) {
      return
    }
    this.isLoggingIn = true
    const { appStore } = this.props
    axios.post('/api/auth/google', {
      credential: response.credential
    }).then(res => {
      const { token, user } = res.data
      if (token) {
        appStore.toggleLogin(true, token, user)
      } else {
        this.isLoggingIn = false
      }
    }).catch(err => {
      this.isLoggingIn = false
      const msg = err.response && err.response.data && err.response.data.message
        ? err.response.data.message
        : '登录失败，请重试'
      alert(msg)
    })
  }

  render () {
    const { error } = this.state
    return (
      <div className={this.props.className}>
        <h3 className='title'>管理员登录</h3>
        <div style={{ padding: '30px 0', textAlign: 'center' }}>
          <p style={{ marginBottom: 24, color: '#999', fontSize: 14 }}>
            请使用已授权的 Google 账号登录
          </p>
          {
            error ?
              <p style={{ marginBottom: 16, color: '#ff7875', fontSize: 13 }}>
                {error}
              </p> :
              null
          }
          <div ref={this.btnRef} style={{ display: 'inline-block' }} />
        </div>
        <div className='footer'>
          <div>欢迎登陆后台管理系统</div>
        </div>
      </div>
    )
  }
}

export default LoginForm



// WEBPACK FOOTER //
// ./src/routes/Login/LoginForm.js